import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/layouts/default.vue").then(m => m.default || m)),
  registration: defineAsyncComponent(() => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/layouts/registration.vue").then(m => m.default || m)),
  results: defineAsyncComponent(() => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/layouts/results.vue").then(m => m.default || m))
}